import React, { useState, useEffect } from 'react';
import {
    Smile, Heart, Star, Zap, Coffee, Laugh,
    Rainbow, Rocket, Headphones, Book,
    Music, Camera, Globe, Lightbulb
} from 'lucide-react';

const DailyMoodLifter = () => {
    const [currentActivity, setCurrentActivity] = useState(null);
    const [animationKey, setAnimationKey] = useState(0);

    const activities = [
        {
            icon: <Smile color="#FFC107" size={48} />,
            text: "You're awesome and capable of amazing things!",
            color: "bg-yellow-100",
            category: "Motivation"
        },
        {
            icon: <Heart color="#FF4081" size={48} />,
            text: "Self-love is the best love. Embrace yourself!",
            color: "bg-pink-100",
            category: "Wellness"
        },
        {
            icon: <Star color="#2196F3" size={48} />,
            text: "Every small step is progress. Keep going!",
            color: "bg-blue-100",
            category: "Achievement"
        },
        {
            icon: <Zap color="#8BC34A" size={48} />,
            text: "Your potential is limitless. Dream big!",
            color: "bg-green-100",
            category: "Inspiration"
        },
        {
            icon: <Coffee color="#795548" size={48} />,
            text: "Take a break. You deserve some relaxation!",
            color: "bg-orange-100",
            category: "Self-Care"
        },
        {
            icon: <Laugh color="#9C27B0" size={48} />,
            text: "Laughter is the best medicine. Smile wide!",
            color: "bg-purple-100",
            category: "Happiness"
        },
        {
            icon: <Rainbow color="#FF5722" size={48} />,
            text: "Embrace diversity and celebrate uniqueness!",
            color: "bg-red-100",
            category: "Empowerment"
        },
        {
            icon: <Rocket color="#00BCD4" size={48} />,
            text: "You're on a journey of continuous growth!",
            color: "bg-teal-100",
            category: "Personal Development"
        },
        {
            icon: <Headphones color="#673AB7" size={48} />,
            text: "Music has the power to heal and inspire!",
            color: "bg-indigo-100",
            category: "Creativity"
        },
        {
            icon: <Book color="#4CAF50" size={48} />,
            text: "Learning is a lifelong adventure. Stay curious!",
            color: "bg-green-200",
            category: "Learning"
        },
        {
            icon: <Lightbulb color="#FFC107" size={48} />,
            text: "Every challenge is an opportunity to grow!",
            color: "bg-amber-100",
            category: "Problem Solving"
        },
        {
            icon: <Music color="#E91E63" size={48} />,
            text: "Let your inner rhythm guide you today!",
            color: "bg-pink-200",
            category: "Expression"
        },
        {
            icon: <Camera color="#3F51B5" size={48} />,
            text: "Capture moments, create memories!",
            color: "bg-indigo-200",
            category: "Mindfulness"
        },
        {
            icon: <Globe color="#009688" size={48} />,
            text: "The world is full of amazing possibilities!",
            color: "bg-teal-200",
            category: "Exploration"
        },
        {
            icon: <Lightbulb color="#FFC107" size={48} />,
            text: "Your ideas have the power to change the world!",
            color: "bg-yellow-200",
            category: "Innovation"
        }
    ];

    const generateActivity = () => {
        const randomActivity = activities[Math.floor(Math.random() * activities.length)];
        setCurrentActivity(randomActivity);
        setAnimationKey(prev => prev + 1);
    };

    useEffect(() => {
        generateActivity();
    }, []);

    return (
        <div className={`flex flex-col items-center justify-center min-h-[300px] p-6 ${currentActivity?.color}`}>
            <div
                key={animationKey}
                className="text-center transform transition-all duration-500 animate-fade-in"
            >
                <div className="mb-4">
                    {currentActivity?.icon}
                </div>
                <h2 className="text-xl font-bold mb-4">
                    {currentActivity?.text}
                </h2>
                <div className="flex space-x-2 justify-center">
                    <button
                        onClick={generateActivity}
                        className="bg-white text-blue-500 hover:bg-blue-50 px-4 py-2 rounded-full shadow-md transition-colors"
                    >
                        New Inspiration
                    </button>
                    <span className="bg-white text-gray-600 px-3 py-2 rounded-full text-sm">
            {currentActivity?.category}
          </span>
                </div>
            </div>
        </div>
    );
};

export default DailyMoodLifter;